import fetch from '@/utils/fetch';

/**
 * 获取账号列表
 * @param query
 */
export function getAccountPage(query) {
    return fetch({
        url: '/User/User/getUserListByOrganizationId',
        method: 'post',
        data: query
    });
}


/**
 * 初始化用户信息
 */
export function getAccount(account) {
    return fetch({
        url: '/User/User/getOrganizationUserByUserId',
        method: 'post',
        data: account
    });
}

/**
 * 根据部门id获取职位列表
 * @param deparmentid 部门id
 */
export function getPostList(deparmentid) {
    return fetch({
        url: '/Rule/Rule/getPostList',
        method: 'post',
        data: deparmentid
    });
}



/**
 * 提交账号信息
 * @param account
 */
export function addAccount(account) {
    return fetch({
        url: '/User/User/registerOrganization',
        method: 'post',
        data: account
    });
}

/**
 * 提交账号信息
 * @param account
 */
export function delAccount(account) {
    return fetch({
        url: '/User/User/delOrganizationUser',
        method: 'post',
        data: account
    });
}

/**
 * 获取公司部门树列表
 * @param query
 */
export function getCompanyOrganizationTree(query) {
    return fetch({
        url: '/Rule/Rule/getCompanyOrganizationTree',
        method: 'post',
        data: query
    });
}

/**
 * 修改账号
 * @param query
 */
export function editAccount(query) {
    return fetch({
        url: '/User/User/updateOrganizationUser',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * @param query
 */
export function getOrganizationAndPostAndUserTreeByMenu(query) {
    return fetch({
        url: '/Rule/Rule/getOrganizationAndPostAndUserTreeByMenu',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * zym.2023-01-12 修改注释信息  重置密码
 * @param query
 */
export function resetPasswordFormAdmin(query) {
    return fetch({
        // url: '/User/User/resetPasswordFormAdmin',
        // url: 'eavar/organization/resetPasswordFormAdmin',
        // 强制改密码的
        url: 'eavar/user/resetPasswordFormAdmin',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥图片 token
 * @param query
 */
export function getFileToken(query) {
    return fetch({
        // url: '/File/File/getToken',
        url: '/eavar/file/getToken',
        method: 'post',
        data: query
    });
}

/**
 * 图片删除
 * @param query
 */
export function detFile(query) {
    return fetch({
        url: '/File/File/deletePFile',
        method: 'post',
        data: query
    });
}





// WEBPACK FOOTER //
// ./src/api/account.js